import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=a54bb4a4&scoped=true&"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=a54bb4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54bb4a4",
  null
  
)

export default component.exports